
const initState = () => ({
})

export const state = initState

export const getters = {
}

export const mutations = {

}

export const actions = {

  async printReceiptReport({}, jobOrderID) {
    try{
      if(jobOrderID && jobOrderID >= 0){
        const response = await this.$axios.get(`webpos/reports/print-receipt/${jobOrderID}`, {responseType: 'blob'})
        if(response){
          const createdFile = new File(
            [response.data],
            "report.pdf" || 'report.pdf',
            {type: 'application/pdf'}
          )
          const url = window.URL.createObjectURL(createdFile)
          window.open(url, '_blank')
        }
        else{
          this.$toast.error('Error while printing report')
        }
      }
      else{
        this.$toast.show('The order that you are trying to print cannot be found')
      }
    }
    catch (ex) {
      if (ex.response && ex.response.status == 404) {
        this.$toast.show('The order that you are trying to print cannot be found')
        return;
      }
      this.$toast.error('Error while printing report')
    }

  },

  async printInvoiceReport({}, invoiceID) {
    try{
      if(invoiceID && invoiceID >= 0) {
        const response = await this.$axios.get(`webpos/reports/print-invoice/${invoiceID}`, {responseType: 'blob'})
        if (response) {
          const createdFile = new File(
            [response.data],
            "report.pdf" || 'report.pdf',
            {type: 'application/pdf'}
          )
          const url = window.URL.createObjectURL(createdFile)
          window.open(url, '_blank')
        }
        else{
          this.$toast.error('Error while printing report')
        }
      }
      else {
        this.$toast.show('The invoice that you are trying to print cannot be found')
      }
    }
    catch (ex) {
      if (ex.response && ex.response.status == 404) {
        this.$toast.show('The invoice that you are trying to print cannot be found')
        return;
      }
      this.$toast.error('Error while printing report')
    }
  },

  async printCustomerCreditReport({}, customerCreditID) {
    if(customerCreditID && customerCreditID > 0){
      this.$axios
        .get(`webpos/reports/print-customer-credit/${customerCreditID}`, {responseType: 'blob'})
        .then((response) => {
          /*  const contentDisposition = response.headers['content-disposition']
           const match = contentDisposition.match(/filename\s*=\s*(\w+-\w+)+/i)
           const [fullFileName, fileName] = match */
          const createdFile = new File(
            [response.data],
            "report.pdf" || 'report.pdf',
            {type: 'application/pdf'}
          )
          const url = window.URL.createObjectURL(createdFile)
          window.open(url, '_blank')
        })
    }

  },

  async printDailyReport({}, {filters}) {
    try{
      const response = await this.$axios.post(`webpos/reports/print-daily-report`, filters, {responseType: 'blob'})
      if(response){
        const createdFile = new File(
          [response.data],
          "report.pdf" || 'report.pdf',
          {type: 'application/pdf'}
        )
        const url = window.URL.createObjectURL(createdFile)
        window.open(url, '_blank')
      }
      else{
        this.$toast.error('Error while printing report')
      }

    }
    catch{
      this.$toast.error('Error while printing report')
    }
  },

  async printStatementReport({}, orderID) {
    try{
      if(orderID && orderID > 0) {
        const response = await this.$axios.get(`webpos/reports/print-layaway-statement/${orderID}`, {responseType: 'blob'})
        if (response) {
          const createdFile = new File(
            [response.data],
            "report.pdf" || 'report.pdf',
            {type: 'application/pdf'}
          )
          const url = window.URL.createObjectURL(createdFile)
          window.open(url, '_blank')
        }
        else{
          this.$toast.error('Error while printing report')
        }
      }
    }
    catch{
      this.$toast.error('Error while printing report')
    }

  },

  async printRepairTicketReport({}, orderID){
    try{
      if(!orderID || orderID <= 0){
        this.$toast.error('Error while printing repair ticket report.')
        return;
      }
      const response = await this.$axios.get(`webpos/reports/print-repair-ticket/${orderID}`, {responseType: 'blob'})
      if(response){
        const createdFile = new File(
            [response.data],
            "report.pdf" || 'report.pdf',
            {type: 'application/pdf'}
        )
        const url = window.URL.createObjectURL(createdFile)
        window.open(url, '_blank')
      }
      else{
        this.$toast.show('The repair order that you are trying to print cannot be found')
      }
    }
    catch(ex){
      if(ex.response && ex.response.status == 404){
        this.$toast.show('The repair job that you are trying to print cannot be found')
        return;
      }
      this.$toast.error('Error while printing report')
    }
  },

  async printTradeInTicketReport({}, tradeInID) {
    try{
      if(tradeInID && tradeInID >= 0){
        const response = await this.$axios.get(`webpos/reports/print-trade-in-ticket/${tradeInID}`, {responseType: 'blob'})
        if(response){
          const createdFile = new File(
              [response.data],
              "report.pdf" || 'report.pdf',
              {type: 'application/pdf'}
          )
          const url = window.URL.createObjectURL(createdFile)
          window.open(url, '_blank')
        }
        else{
          this.$toast.error('Error while printing report')
        }
      }
      else{
        this.$toast.show('The item that you are trying to print cannot be found')
      }
    }
    catch (ex) {
      if (ex.response && ex.response.status == 404) {
        this.$toast.show('The item that you are trying to print cannot be found')
        return;
      }
      this.$toast.error('Error while printing report')
    }
  }
}
